import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Key, KeyRaw } from '@shared/models/key';
import { BcmApi2Service } from '@modules/bcm/@shared/services';

@Injectable({
    providedIn: 'root'
})
export class KeyApiService extends BcmApi2Service {

    getAll(params: HttpParams = new HttpParams()): Observable<Key[]> {
        return super.get<any>('keys', params)
            .pipe(
                map((response: KeyRaw[]) => {
                    return response.map(key => new Key(key));
                })
            );
    }

    count(params: HttpParams = new HttpParams()): Observable<number> {
        return super.get<number>('keys/count', params);
    }

    getById(id: number, params: HttpParams = new HttpParams()): Observable<Key> {
        return super.get<any>(`keys/${id}`, params)
            .pipe(
                map((response: KeyRaw) => new Key(response))
            );
    }

    create(key: Key): Observable<any> {
        return super.post(`keys`, key);
    }

    updateById(key: Key): Observable<any> {
        return super.put(`keys/${key.id}`, key);
    }

    deleteById(key: Key): Observable<any> {
        return super.delete(`keys/${key.id}`);
    }
}
